import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
    getAllCountiesByCityName,
    getDistrictTownList,
    getZoneDistrictTotal,
    getZoneDistrictTotalByCity, initialWebWillMount,
    refreshSearchMapSelectedDistrictList,
    refreshSelectedZoneId,
    refreshZoneMapCenterZoom,
    refreshZoneMapShowPointFlag,
    searchMapZoneList
} from "../../../../actions/ZoneAction";
import { FuzzySearchType, MAP_STYLE_ID } from "../../../../Enums";
import SearchCondition from "../components/SearchCondition";
import ZoneShowCard from "./ZoneShowCard";
import { Carousel, message } from "antd";
// import "../../../../../../utils/RichMarker.js"
import LogoHeader from "../components/LogoHeader";
import ListIcon from '@material-ui/icons/List';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import { RoutePath } from "../../../../../../constants/RoutePath";
import "./Index.css";
import "../../../../../../utils/RichMarker";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import MTabBar from '../../../../../../components/MTabBar';
import { CACHE_SESSION_USER } from '../../../../../../constants/Profile';
const specialCity = ['昆山市', '太仓市', '张家港市', '常熟市']
let bmapZone;
//默认操作Flag（放大/缩小）
let defaultOperationFlag = false;
let lastItemIndex;

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formatMessage: this.props.intl['formatMessage'],
            dragFlag: false,
            borderingCity: "",
            showCityChangeNotice: false,
        }
    }

    componentWillMount() {
        const self = this;

        initialWebWillMount(this.props, (city, condition) => {
            condition.pageSize = 20;
            // condition.recommendOrderFlag = 1;
            condition.zoneDistrictList = [];
            //查询当前城市所有的行政区域内仓库总数
            self.props.dispatch(getZoneDistrictTotalByCity(city));
            self.props.dispatch(getZoneDistrictTotal(condition));
            self.props.dispatch(refreshZoneMapShowPointFlag(false));
            self.props.dispatch(getDistrictTownList(city));

            self.props.dispatch(getAllCountiesByCityName(city));
        })



        // self.props.dispatch(searchShowZoneList(searchCondition, self.state.formatMessage));//地图

    }

    _handleRecordMapViewScrollTop() {

        if (bmapZone) {
            let mapCenterZoom = {};
            mapCenterZoom.zoom = bmapZone.getZoom();
            mapCenterZoom.center = bmapZone.getCenter();
            this.props.dispatch(refreshZoneMapCenterZoom(mapCenterZoom));
        }
    }

    componentDidMount() {
        const self = this;
        const { searchCondition, cityName } = this.props;
        // let searchConditionCookie = Object.assign({}, cookie.load('searchCondition'));
        // searchConditionCookie.currentPage = 1;
        bmapZone = new window.BMap.Map("bmapZone");    // 创建Map实例

        bmapZone.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        bmapZone.setMinZoom(10);
        bmapZone.setMaxZoom(13);
        // bmapZone.enablePinchToZoom(true);     //启用双指操作缩放，默认启用
        // bmapZone.enableContinuousZoom(true);     //启用连续缩放效果，默认禁用
        // bmapZone.enableInertialDragging(true);     //启用地图惯性拖拽，默认禁用


        let defaultZoom = 10;
        let centerPoint;
        let doSearchZoneList = false;

        if ((searchCondition && searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location)) {

            if (searchCondition.rectangleCenterPointLat && searchCondition.rectangleCenterPointLat != null &&
                searchCondition.rectangleCenterPointLng && searchCondition.rectangleCenterPointLng !== null) {
                centerPoint = new window.BMap.Point(searchCondition.rectangleCenterPointLng, searchCondition.rectangleCenterPointLat);
                defaultZoom = 12;
                doSearchZoneList = true;
            }


        }


        let mapCenterZoom = this.props.mapCenterZoom;
        if (mapCenterZoom) {
            bmapZone.centerAndZoom(mapCenterZoom.center, mapCenterZoom.zoom);
            this.props.dispatch(refreshZoneMapCenterZoom(undefined));
        } else if (centerPoint) {
            bmapZone.centerAndZoom(centerPoint, defaultZoom);
        } else {
            bmapZone.centerAndZoom(new window.BMap.Point(121.50, 31.33), defaultZoom);
        }
        bmapZone.setMapStyleV2({ styleId: MAP_STYLE_ID });


        if (!mapCenterZoom && !centerPoint && cityName) {
            defaultOperationFlag = false;
            bmapZone.setCenter(cityName);
        }
        if (doSearchZoneList) {
            this._handleMapZoom();
        }

        bmapZone.addEventListener('zoomend', (e) => {

            let center = bmapZone.getCenter();
            console.log(center);
            // if(!this.state.dragFlag){
            self._handleMapZoom();
            // }

        });

        bmapZone.addEventListener('dragend', (e) => {

            let center = bmapZone.getCenter();
            console.log(center);
            self._handleMapMove();
            self.setState({ dragFlag: false })
            console.log(e);
        });

        bmapZone.addEventListener('dragstart', (e) => {
            self.setState({ dragFlag: true })
            console.log(e);
        });
        bmapZone.addEventListener('touchstart', (e) => {
            // alert(bmapZone.getZoom())
            let center = bmapZone.getCenter();
            console.log(e);
        });


    }

    _constructBMapCallback(bMap) {
        this.setState({ bMap: bMap })
    }

    _handleMapMove() {
        if (defaultOperationFlag) {
            //移动地图时触发
            const zoom = bmapZone.getZoom();
            if (zoom >= 12) {
                // if (this.props.doMoveMapResearchFlag && this.props.searchCondition.searchFuzzyType !== FuzzySearchType.Enums.Location) {
                this._searchZoneListByMapBounds();
                // }
                this.props.dispatch(refreshZoneMapShowPointFlag(true));
            }
        }
        else {
            defaultOperationFlag = true;
        }

        //隐藏仓库弹出式信息框
        // this._hideZoneTooltip();
        // //显示接壤城市的仓库数量
        this._handleCheckBorderingCity();
    }

    /**
     * 搜索接壤行政区的仓库数量
     * @private
     */

    _handleCheckBorderingCity() {
        const self = this;
        // const zoom = zonesMap.getZoom();
        // if (zoom < 12) {
        //     return;
        // }

        //根据地图中心点坐标获得该点的省市区
        let province;
        let point = bmapZone.getCenter();
        let getData = new window.BMap.Geocoder();
        let cityName = this.props.cityName;
        //接壤行政区

        // borderingDistrict = null;
        getData.getLocation(point, function (rs) {
            let location = rs.addressComponents;
            //若中心点非当前城市
            let currentCity = location.city;
            if (location.city !== cityName
                && (self.state.borderingCity === undefined || self.state.borderingCity === "" || self.state.borderingCity !== currentCity)) {
                self.setState({ showCityChangeNotice: true, borderingCity: currentCity });
            }
        });
    }

    _handleChangeZoomCenterByOtherOperation(zoom, centerPoint) {
        defaultOperationFlag = false;
        if (zoom && centerPoint) {

            bmapZone.centerAndZoom(centerPoint, zoom);
        } else if (zoom) {
            bmapZone.setZoom(zoom);
        } else if (centerPoint) {
            bmapZone.setCenter(centerPoint);
        }
        if (zoom) {
            if (zoom >= 12) {
                this.props.dispatch(refreshZoneMapShowPointFlag(true));
            } else {
                this.props.dispatch(refreshZoneMapShowPointFlag(false));

            }
        }
    }

    //缩放比例时触发
    _handleMapZoom() {

        const zoom = bmapZone.getZoom();
        const { searchCondition, selectedDistrictList } = this.props;
        if (defaultOperationFlag) {
            // alert(zoom)
            if (searchCondition) {
                if (zoom >= 12) {
                    this._searchZoneListByMapBounds();
                    this.props.dispatch(refreshZoneMapShowPointFlag(true));
                } else {
                    this.props.dispatch(refreshZoneMapShowPointFlag(false));
                }
            }
        } else {
            defaultOperationFlag = true;
        }

    }

    /**
     * 根据地图范围检索
     * @private
     */
    _searchZoneListByMapBounds(callBack) {

        const { searchCondition, zoneCoordinateMap, selectedDistrictList } = this.props;
        //中心点
        let centerPoint = bmapZone.getCenter();

        //条件设定
        const bounds = bmapZone.getBounds();
        const southWest = bounds.getSouthWest();
        const northEast = bounds.getNorthEast();
        searchCondition.zonePointWest = southWest.lng;
        searchCondition.zonePointEast = northEast.lng;
        searchCondition.zonePointSouth = southWest.lat;
        searchCondition.zonePointNorth = northEast.lat;

        searchCondition.zoneDistrictList = [];
        if (searchCondition.searchFuzzyType !== FuzzySearchType.Enums.Location) {
            searchCondition.rectangleCenterPointLng = centerPoint.lng;
            searchCondition.rectangleCenterPointLat = centerPoint.lat;
            searchCondition.mapSearchRange = null;
        }

        //后台根据此中心点进行距离排序
        searchCondition.recommendOrderFlag = 0;
        searchCondition.sortField = 'distance_order';
        searchCondition.sortType = 'asc';


        this.props.dispatch(searchMapZoneList(searchCondition, zoneCoordinateMap, this.props.selectedZoneId, callBack));

    }

    _handleClickPolygon(existZoneDistrict, point) {
        //根据选中的行政区检索
        const { doMoveMapResearchFlag } = this.props;
        let districtList = [existZoneDistrict.district];
        this.props.dispatch(refreshSearchMapSelectedDistrictList(districtList));

        //放大地图
        this._handleChangeZoomCenterByOtherOperation(12, point);
        this._searchZoneListByMapBounds(() => {
            if (this.props.limit) {
                let [type, count] = this.props.limit.split('_')
                const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER)) || {}
                let isLogin = !!(user && user.id)
                let authStatus = this.props.authStatus
                let info = `
                    搜索次数已达上限，当前${!isLogin ? '未登录' : ''}${authStatus ? '已认证' : '未认证'}，搜索次数已达上限 (${count}次/天),
                    ${!isLogin ? '登录后' : ''}${(isLogin && !authStatus) ? '电脑端访问，认证后' : ""}，可使用更多搜索次数
                `
                message.info({
                    content: info,
                    duration: 10,
                    className: '_mapTip',
                });
            }
        });

    }

    /**
     * 显示仓库标记点
     * @private
     */
    _renderBMapMarket() {
        const { showPointFlag, searchCondition } = this.props;

        if (!bmapZone) {
            return;
        }
        bmapZone.clearOverlays();
        //如果搜索范围列表有数据，就绘制搜索范围列表的点。

        if (showPointFlag) {
            this._renderZonePoint();
        } else {
            console.log(this.props.cityName)
            if (specialCity.includes(this.props.cityName)) {
                this._renderPolygonspecial()
            } else {
                this._renderPolygon()
            }
        }

        if (searchCondition && searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location) {
            this._renderFuzzyLocation();

        } else {
            this._renderMyPosition();
        }


    }

    _renderMyPosition() {
        const { currentLocation } = this.props;
        if (currentLocation) {
            let point = new window.BMap.Point(currentLocation.lng, currentLocation.lat);
            //离点的偏移量
            const PointAnchor = new window.BMap.Size(-10, -12);//调整了一下偏移量
            let informationHtml = "<div class='map-current-location'>" + "</div>";
            let myRichMarkerObject = new window.BMapRichMarkerLib.RichMarker(informationHtml, point,
                { anchor: PointAnchor, enableDragging: false, "ZIndex": 10 });
            bmapZone.addOverlay(myRichMarkerObject);

        }


    }

    _renderFuzzyLocation() {
        const { searchCondition } = this.props;
        if (searchCondition && searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location) {
            let point = new window.BMap.Point(searchCondition.rectangleCenterPointLng, searchCondition.rectangleCenterPointLat);
            //离点的偏移量
            const PointAnchor = new window.BMap.Size(-10, -12);//调整了一下偏移量
            let informationHtml = "<div class='map-fuzzy-location'>" + "</div>";
            let myRichMarkerObject = new window.BMapRichMarkerLib.RichMarker(informationHtml, point,
                { anchor: PointAnchor, enableDragging: false, "ZIndex": 10 });
            bmapZone.addOverlay(myRichMarkerObject);

        }


    }


    /**
     * 绘制仓库标记点
     */
    _renderZonePoint() {

        let zoneDistrictList = this.props.selectedDistrictList ? this.props.selectedDistrictList : [];
        let zoneList = this.props.bMapZoneList ? this.props.bMapZoneList : [];
        let selectedZoneId = this.props.selectedZoneId ? this.props.selectedZoneId : "";

        const self = this;
        //遍历所有仓库
        zoneList.map((item, index) => {
            let rentShowLabel = item.rentShow;
            if (item.rentShow === "面议") {
                rentShowLabel = "面议";
            }
            // let rent = "面议";
            // if (item.rentEffective !== 0) {
            //     rent = MoneyFormat.formatTwo(item.rentEffective);
            // }

            //区分标记的颜色 // 根据是否是当前选择的行政区 或者 未执行行政区
            let labelStyle = (zoneDistrictList.length === 0 || zoneDistrictList.includes(item.district)) ?
                "map-zone-point"
                : "map-zone-point-outarea";

            //控制颜色,加了hover
            let informationHtml = "<div class='" + labelStyle + "'>" + rentShowLabel + "<div class='arrow'></div></div>";
            //控制ZIndex
            let className = labelStyle + "-box";
            //点击某个点时触发
            if (selectedZoneId === item.id) {
                className = labelStyle + "-box-click";
                //没加hover
                informationHtml = "<div class='" + labelStyle + "-click'>" + rentShowLabel + "<div class='arrow'></div></div>";
            }

            let point = new window.BMap.Point(item.longitude, item.latitude);
            //离点的偏移量
            const PointAnchor = new window.BMap.Size(-46, -34);//调整了一下偏移量
            let myRichMarkerObject = new window.BMapRichMarkerLib.RichMarker(informationHtml, point,
                { anchor: PointAnchor, enableDragging: false, "ZIndex": 10, "className": className });
            // 红色的点，用来确认偏移量的
            //             let marker = new  window.BMap.Marker( item.point);
            //             bmapZone.addOverlay(marker);
            myRichMarkerObject.addEventListener("ontouchend", function (e) {

                if (lastItemIndex !== item.id) {
                    //解决chrome浏览器上onmouseover反复执行而导致外部回调不触发的问题
                    //（Firefox没有这个问题）
                    lastItemIndex = item.id;
                    self.props.dispatch(refreshSelectedZoneId(item.id));

                }

            });

            // // myRichMarkerObject.addEventListener("onmouseover", function (e) {
            // //
            // //     if (lastItemIndex !== item.id) {
            // //         //解决chrome浏览器上onmouseover反复执行而导致外部回调不触发的问题
            // //         //（Firefox没有这个问题）
            // //         lastItemIndex = item.id;
            // //         self.props.dispatch(refreshSelectedZoneId(item.id));
            // //     }
            // //
            // // });
            // //
            // myRichMarkerObject.addEventListener("onmouseout", function (e) {
            //     console.log(e);
            //     lastItemIndex = "";
            //     //隐藏仓库弹出式信息框
            //     // self.props.dispatch(refreshSelectedZoneId(""));
            //
            // });

            bmapZone.addOverlay(myRichMarkerObject);

        });
    }


    /** 绘制区域描边
     * @param zoneDistrictTotal
     * @param allCounties
     * @private
     */
    _renderPolygon() {
        let selectedDistrictList = this.props.selectedDistrictList ? this.props.selectedDistrictList : []
        let allCounties = this.props.allCounties ? this.props.allCounties : []

        let zoneDistrictTotalWithCondition = this.props.zoneDistrictTotalWithCondition ? this.props.zoneDistrictTotalWithCondition : []
        let zoneDistrictTotal = this.props.zoneDistrictTotal ? this.props.zoneDistrictTotal : []

        //区域描边样式
        let normalStyle = {
            strokeWeight: 2,
            strokeColor: "#257AFB",
            strokeStyle: "dashed",
            fillOpacity: 0.5,
            strokeOpacity: 0.5,
            fillColor: "#fff"
        };
        //区域描点样式
        let labelEnterStyle = {
            width: "64px",
            height: "64px",
            fontSize: "12px",
            // opacity: 0.8,
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            border: "1px solid transparent",
            borderRadius: "50%",
            overflow: "hidden",
            textAlign: "center",
            backgroundColor: "#13376D",
            color: "#fff",
            zIndex: 50
        };

        let labelStyle = Object.assign({}, labelEnterStyle, {
            backgroundColor: "#046aff",
            zIndex: 100,
        });
        let zoneDistrictTotalMap = {};
        zoneDistrictTotal.forEach(item => {
            zoneDistrictTotalMap[item.district] = item;
        });
        let zoneDistrictTotalWithConditionMap = {};
        zoneDistrictTotalWithCondition.forEach(item => {
            zoneDistrictTotalWithConditionMap[item.district] = item;
        });
        //遍历当前城市的所有区域
        allCounties.forEach((item, index) => {
            let point = new window.BMap.Point(item.longitude, item.latitude);
            let existZoneDistrict = {};
            if (zoneDistrictTotalMap[item.name]) {
                //获取有房源的区域
                if (zoneDistrictTotalWithConditionMap[item.name]) {
                    existZoneDistrict = zoneDistrictTotalWithConditionMap[item.name];
                } else {
                    existZoneDistrict = { district: item.name, count: 0, }
                }


                // 半透明遮蔽罩
                let plyList = [];
                for (let i = 0; i < item.locationRangList.length; i++) {
                    let ply = new window.BMap.Polygon(item.locationRangList[i], normalStyle); //建立多边形覆盖物
                    // bmapZone.addOverlay(ply);
                    plyList.push(ply);
                }

                if (existZoneDistrict.district) {

                    let label = new window.BMap.Label('<div>' + existZoneDistrict.district + '</div><div>' + existZoneDistrict.count + '个</div>', { position: point });  //设置文本偏移量 // 创建文本标注对象
                    label.setStyle(labelEnterStyle);
                    // label.addEventListener('mouseover', () => {
                    //     plyList.forEach(ply => {
                    //         ply.setFillColor("#DDE7F6");
                    //     });
                    //     label.setStyle(labelStyle);
                    // })
                    // label.addEventListener('mouseout', () => {
                    //     plyList.forEach(ply => {
                    //         ply.setFillColor("#fff");
                    //     });
                    //     label.setStyle(labelEnterStyle);
                    // });
                    label.addEventListener('click', () => {
                        this._handleClickPolygon(existZoneDistrict, point);
                    });

                    bmapZone.addOverlay(label);
                    label.setPosition(point);
                }
            }
        })
    }

    // 特殊城市的区域渲染
    _renderPolygonspecial = () => {
        let zoneDistrictTotalWithCondition = this.props.zoneDistrictTotalWithCondition ? this.props.zoneDistrictTotalWithCondition : []

        //区域描点样式
        let labelEnterStyle = {
            width: "64px",
            height: "64px",
            fontSize: "12px",
            // opacity: 0.8,
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            border: "1px solid transparent",
            borderRadius: "50%",
            overflow: "hidden",
            textAlign: "center",
            backgroundColor: "#13376D",
            color: "#fff",
            zIndex: 50
        };

        //遍历当前城市的所有区域
        zoneDistrictTotalWithCondition.forEach((item, index) => {
            let point = new window.BMap.Point(item.lng, item.lat);

            if (item.district) {

                let label = new window.BMap.Label('<div>' + item.district + '</div><div>' + item.count + '个</div>', { position: point });  //设置文本偏移量 // 创建文本标注对象
                label.setStyle(labelEnterStyle);
                label.addEventListener('click', () => {
                    this._handleClickPolygon(item, point);
                });

                bmapZone.addOverlay(label);
                label.setPosition(point);

            }
        })
    }

    handleChangeCity(cityName) {
        if (bmapZone) {
            defaultOperationFlag = false;
            bmapZone.centerAndZoom(cityName, 10);
        }
    }

    _handlePrev(e) {
        this.carousel.prev();
        e.stopPropagation();
    }

    _handleNext(e) {
        this.carousel.next();
        e.stopPropagation();
    }

    _handleGotoList() {


        // if (window.__wxjs_environment === 'miniprogram') {
        //     //使用navigateTo跳转到小程序路径中
        //     window.wx.miniProgram.navigateTo({
        //         url: '/modules/wms/views/zone/list/index'
        //     })
        // }else{
        this.props.router.navigate(RoutePath.WMS_ZONE_LIST.path);

        // }
    }

    render() {
        const { showMap, router } = this.props;
        let bMapZoneList = this.props.bMapZoneList ? this.props.bMapZoneList : [];
        let selectedZoneId = this.props.selectedZoneId ? this.props.selectedZoneId : "";
        let noticeArrowPath = require("../../../../../../images/bmap/notice-arrow.svg")
        let zone;
        let zoneIndex = 0;
        if (bMapZoneList.length > 0) {

            bMapZoneList.forEach((zone, index) => {
                if (zone.id === selectedZoneId) {
                    zoneIndex = index;

                }
            });
        }
        if (this.carousel) {
            this.carousel.goTo(zoneIndex, false);
        }

        let zoom = 10;
        if (bmapZone) {
            zoom = bmapZone.getZoom();
        }


        return (
            <div className="zone-bmap-box tabbarBottom">
                <LogoHeader />
                <SearchCondition inList={false} {...this.props} showCityTopLevel={this.state.showCityChangeNotice}
                    changeMapFunction={(cityName) => this.handleChangeCity(cityName)} />
                <div className={"bmap-div"}>
                    <div id="bmapZone" style={{ height: '100%' }} />
                    {this._renderBMapMarket()}
                    <div className="bmap-zone-zoom-box">
                        <div className="bmap-zone-zoom-box-location" onClick={() => {
                            let currentLocation = this.props.currentLocation;

                            if (currentLocation) {
                                let point = new window.BMap.Point(currentLocation.lng, currentLocation.lat);
                                bmapZone.centerAndZoom(point, 13);
                                this._handleMapMove();
                            }
                        }}>
                            <div className="bmap-zone-zoom-box-location-item"><MyLocationIcon /></div>
                            <div className="bmap-zone-zoom-box-location-item"> 当前</div>
                            <div className="bmap-zone-zoom-box-location-item">位置
                            </div>
                        </div>
                        <div className={"bmap-zone-zoom-box-number " + (zoom >= 13 ? "number-disable" : "")}
                            onClick={() => {
                                if (zoom < 13) {
                                    bmapZone.zoomIn();
                                    if (zoom === 10 || zoom === 12) {
                                        //这个两个临界值时，页面上的内容不变，不会自动Render所以手动刷一下，为了按钮+-变色

                                        this.forceUpdate();
                                    }
                                }
                            }}><AddIcon /></div>
                        <div className={"bmap-zone-zoom-box-number " + (zoom <= 10 ? "number-disable" : "")}
                            onClick={() => {
                                if (zoom > 10) {
                                    bmapZone.zoomOut();
                                    if (zoom === 11 || zoom === 10) {
                                        //这个两个临界值时，页面上的内容不变，不会自动Render所以手动刷一下，为了按钮-+变色
                                        this.forceUpdate();
                                    }
                                }
                            }}><RemoveIcon /></div>
                    </div>
                    {
                        this.props.showPointFlag && bMapZoneList.length > 0 ?
                            <div className="bmap-zone-box">
                                <div className="bmap-zone-return-list" onClick={() => {
                                    this._handleGotoList();
                                }}><ListIcon />回到列表
                                </div>
                                <div className="zone-carousel-button button-prev" onClick={(e) => this._handlePrev(e)}>
                                    <ArrowBackIosIcon className="zone-carousel-button-svg" />
                                </div>
                                <div className='zone-carousel-button button-next' onClick={(e) => this._handleNext(e)}>
                                    <ArrowForwardIosIcon className="zone-carousel-button-svg" />
                                </div>
                                <Carousel ref={dom => {
                                    this.carousel = dom;
                                }}
                                    afterChange={(selectedIndex) => {
                                        if (selectedIndex !== zoneIndex) {
                                            let zone = bMapZoneList[selectedIndex];
                                            this.props.dispatch(refreshSelectedZoneId(zone.id));

                                        }
                                    }}
                                    activedIndex={zoneIndex}
                                    dots={false}
                                    infinite={true}
                                >

                                    {bMapZoneList.map((zone, index) => {

                                        return <ZoneShowCard zone={zone} key={index} {...this.props}
                                            viewPositionFunction={() => this._handleRecordMapViewScrollTop()}
                                        />
                                    }
                                    )}
                                </Carousel>

                            </div>
                            : <div className="bmap-zone-return-list-big-box">
                                <div className="bmap-zone-return-list-big" onClick={() => {
                                    this._handleGotoList();
                                }}><ListIcon />回到列表
                                </div>
                            </div>
                    }

                </div>
                {this.state.showCityChangeNotice ?
                    <div className="bmap-notice-mask">
                        <div className="bmap-notice-arrow"><img src={noticeArrowPath} /></div>
                        <div className="bmap-notice-message-box">
                            <div className="bmap-notice-message-parts1">
                                <div className="bmap-notice-message-info">点击右上角<br />切换到其他城市看看吧？</div>
                            </div>
                            <div className="bmap-notice-message-button"
                                onClick={() => this.setState({ showCityChangeNotice: false })}>我知道了
                            </div>
                        </div>

                    </div> : null}


                <MTabBar router={router} index={2} />
            </div>
        );
    }
}


function mapStateToProps(store) {
    return {
        showPointFlag: store.WMSZoneReducer.showPointFlag,
        bMapZoneList: store.WMSZoneReducer.bMapZoneList,
        selectedZoneId: store.WMSZoneReducer.selectedZoneId,
        selectedDistrictList: store.WMSZoneReducer.selectedDistrictList,
        zoneDistrictTotalWithCondition: store.WMSZoneReducer.zoneDistrictTotalWithCondition,
        cityName: store.WMSZoneReducer.cityName,

        zoneDistrictTotal: store.WMSZoneReducer.zoneDistrictTotal,
        allCounties: store.WMSZoneReducer.allCounties,
        searchCondition: store.WMSZoneReducer.searchCondition,
        currentLocation: store.WMSZoneReducer.currentLocation,
        zoneCoordinateMap: store.WMSZoneReducer.zoneCoordinateMap,
        mapCenterZoom: store.WMSZoneReducer.mapCenterZoom,
        limit: store.WMSZoneReducer.limit,
        authStatus: store.UserReducer.authStatus,

    }
}

export default connect(mapStateToProps)(injectIntl(Index));